import React, {useState, useEffect} from "react";
import MyPageAnnounceBoard from "../components/MyPageAnnounceBoard";
import MyPageAttend from "../components/MyPageAttend";
import MyPageCalendar from "../components/MyPageCalendar";
import ManagerMyPageAttendList from "../components/ManagerMyPageAttendList"
import config from "../config/config";
const API_URL = config.API_URL;

function ManagerMypage() {
  const [attendInfo, setAttendInfo] =useState([]);
  const [loading, setLoading] = useState(false);

  const daysInMonth = getDaysInCurrentMonth();

  // API 호출 함수
  const fetchData = async () => {
    try {
      const response = await fetch(`${API_URL}/api/commute/getIncubatorDailyCommute`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      // console.log(result.value);

      if (result.result) {
        // 데이터를 변환하여 company -> startup_name 매핑
        const formattedData = {
          attend: result.value.commute || 0,
          leave : result.value.leave || 0,
          absence : result.value.absence || 1,
          total: result.value.nb_of_startups || 1, 
        };
        setAttendInfo(formattedData);
      } else {
        console.error("데이터 가져오기 실패:", result.message);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      // setError(error.message); // 에러 메시지 저장
    } finally {
      setLoading(false); // 데이터 로딩 완료
    }
  };
  useEffect(() => {
    fetchData();
  }, []);
  console.log(attendInfo);

  return (
    <div style={styles.main}>
      <div style={styles.topLine}>
        <MyPageCalendar style={{flex:"4"}}/>
        {loading ? (
          <p>Loading...</p>
        ):(
          // 일반 MyPage와 다르게 비율로 보내는게 아니고 그냥 개수로 보낸다.
          <MyPageAttend style={{flex:"7"}} attend={attendInfo.attend} 
          absence={attendInfo.absence} total={attendInfo.total}
          manager={true}/>
        )}
      </div>
      <div style={styles.bottomLine}>
        <ManagerMyPageAttendList style={{flex:"1"}}/>
        <MyPageAnnounceBoard style={{flex:"1", paddingTop: "20px", paddingBottom: "55px"}}/>
      </div>     
    </div>
  );  
}


function getDaysInCurrentMonth(){
  // 현재 한국 시간 가져오기
  const now = new Date();
  const kstOffset = 9 * 60; // KST(UTC+9) offset (분 단위)
  const kstTime = new Date(now.getTime() + kstOffset * 60 * 1000);

  // 현재 연도와 월 구하기
  const year = kstTime.getFullYear();
  const month = kstTime.getMonth() + 1; // 월은 0부터 시작하므로 +1

  // 해당 월의 마지막 날짜 구하기
  const lastDay = new Date(year, month, 0).getDate();
  return lastDay;
}

const styles ={
  main :{
    display: "flex",
    gap: "20px",
    flexDirection: "column",
    flex: "1",
    padding: "16px"
  },
  topLine:{
    display: "flex",
    gap: "20px",
    // height: "424px"
  },
  bottomLine:{
    display: "flex",
    flex: "1",
    gap: "20px"
  }
}

export default ManagerMypage;